import { resolveAuth0ScopeRows } from "./auth0ScopeConfig.js";

/**
 * @param {{ granted?: string[], scopeStatus?: { scope: string, granted: boolean, tier: string }[], compact?: boolean }} props
 */
export default function Auth0ScopeStatusList({ granted = [], scopeStatus, compact = false }) {
  const rows = resolveAuth0ScopeRows(granted, scopeStatus);
  const missingRecommended = rows.filter((r) => r.tier === "recommended" && !r.granted);

  return (
    <div style={{ marginTop: compact ? 0 : "12px", marginBottom: compact ? 0 : "12px" }}>
      <p className="text-secondary" style={{ fontSize: "12px", marginBottom: "8px" }}>
        M2M scopes ({rows.filter((r) => r.granted).length}/{rows.length} granted)
      </p>
      <ul
        style={{
          listStyle: "none",
          margin: 0,
          padding: 0,
          display: "grid",
          gap: "4px",
          fontSize: "12px",
        }}
      >
        {rows.map((row) => (
          <li key={row.scope} style={{ display: "flex", gap: "8px", alignItems: "baseline" }}>
            <span style={{ color: row.granted ? "var(--status-ok, #4ade80)" : "var(--text-dim)" }}>
              {row.granted ? "✓" : "✗"}
            </span>
            <span style={{ color: "var(--text-primary)" }}>
              <code style={{ fontSize: "11px", color: "inherit" }}>{row.scope}</code>
              {row.tier === "recommended" ? (
                <span className="text-dim" style={{ marginLeft: "6px" }}>
                  (recommended)
                </span>
              ) : null}
            </span>
          </li>
        ))}
      </ul>
      {missingRecommended.length > 0 ? (
        <p className="text-dim" style={{ fontSize: "12px", marginTop: "10px", lineHeight: 1.45 }}>
          Connection works; {missingRecommended.length} additional scope
          {missingRecommended.length === 1 ? "" : "s"} will enable richer MFA + admin findings.
        </p>
      ) : null}
    </div>
  );
}
